// extracted by mini-css-extract-plugin
export var column = "_tg-0";
export var divider = "_tg-2";
export var timePicker = "_tg-1";